const POPUP_NAME = "pp-fb-group";
const PREF_KEY = "pp_fast_popup";
let popupRef = null;

export const getPopupPref = () => localStorage.getItem(PREF_KEY) !== "0";
export const setPopupPref = (on) => localStorage.setItem(PREF_KEY, on ? "1" : "0");

// Opens (or reuses) a single popup window docked on the right half of the screen.
// Returns "popup" | "tab" | "blocked".
export function openGroupWindow(url, usePopup = true) {
  if (!usePopup) {
    window.open(url, "_blank", "noopener,noreferrer");
    return "tab";
  }
  const sw = window.screen.availWidth || 1280;
  const sh = window.screen.availHeight || 800;
  const w = Math.max(480, Math.min(900, Math.round(sw * 0.5)));
  const left = (window.screen.availLeft || 0) + sw - w;
  const top = window.screen.availTop || 0;
  const features = `popup=yes,width=${w},height=${sh},left=${left},top=${top},resizable=yes,scrollbars=yes`;
  try {
    if (popupRef && !popupRef.closed) {
      popupRef.location.href = url;
    } else {
      popupRef = window.open(url, POPUP_NAME, features);
    }
  } catch {
    popupRef = window.open(url, POPUP_NAME, features);
  }
  if (!popupRef) return "blocked";
  try { popupRef.opener = null; } catch { /* cross-origin */ }
  popupRef.focus();
  return "popup";
}

export function closeGroupWindow() {
  if (popupRef && !popupRef.closed) popupRef.close();
  popupRef = null;
}
